<template>
  <div class="flex flex-row">
    <div class="flex flex-col w-16">
      <div :class="stepClass">{{ index + 1 }}</div>
      <div class="font-bold text-center mt-2 text-sm leading-tight" :class="{ 'text-gray-500': !isActive }">
        <slot />
      </div>
    </div>
    <div v-if="!isLast" class="bg-gray-400 h-1 w-12 mt-8"></div>
  </div>
</template>

<script>
export default {
  name: 'step-item',
  data () {
    return {
      index: 0,
      isLast: false,
      isActive: false
    }
  },
  computed: {
    stepClass () {
      return {
        'rounded-full shadow-md border-2 w-16 h-16 border-red-500 flex justify-center items-center text-2xl font-bold': true,
        'bg-white text-red-500': !this.isActive,
        'bg-red-500 text-white': this.isActive
      }
    }
  }
}
</script>

